
























































































































import { Component, Inject, Vue } from "vue-property-decorator";
import { AttivitaService } from "@/data/services/attivita.service";
// @ts-ignore
import VueCal from "vue-cal";
import "vue-cal/dist/i18n/it.js";
import "vue-cal/dist/vuecal.css";

import { VPopover } from "v-tooltip";

@Component({
  components: {
    VueCal,
    "v-popover": VPopover,
  },
})
export default class Eventi extends Vue {
  @Inject("AttivitaService") attivitaService!: AttivitaService;

  eventUrl: string = process.env.VUE_APP_EVENT_URL as string;

  events: any[] = [];

  start!: number;
  end!: number;

  loading = false;

  now: Date = new Date();

  loadAttivita() {
    this.loading = true;
    this.attivitaService
      .getAttivitaLatest(6)
      .then((result) => {
        this.events = [];
        result.forEach((r) => {
          if (r.giornate && r.giornate.length) {
            const g = r.giornate[0];
            this.events.push({
              start: g.inizio,
              end: g.fine,
              class: "elb-event",
              _attivita: r,
              _giornata: g,
            });
          }
        });
      })
      .finally(() => (this.loading = false));
  }

  onViewChange(event: any) {
    this.start = event.startDate;
    this.end = event.endDate;
    this.loadAttivita();
  }

  beforeMount() {
    const now = new Date();
    this.start = new Date(
      now.getFullYear(),
      now.getMonth(),
      1,
      0,
      0,
      0,
      0
    ).getTime();
    this.end = new Date(
      now.getFullYear(),
      now.getMonth() + 1,
      1,
      0,
      0,
      0,
      0
    ).getTime();
    this.loadAttivita();
  }
}
